var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('path',{attrs:{"d":"M0 0h9.09v9.09H0zM10.91 0H20v9.09h-9.09zM0 10.91h9.09V20H0zM10.91 10.91H20V20h-9.09z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }